import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PracenjeLageraService } from '../pracenje-lagera.service';

@Injectable({
  providedIn: 'root',
})
export class PracenjeLageraGuard implements CanActivate {
  constructor(
    private _pracenjeLageraService: PracenjeLageraService,
    private _router: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this._pracenjeLageraService
      .prikaziLager()
      .pipe(
        map((prikazi) =>
          prikazi ? true : this._router.createUrlTree(['/robno', 'magacini'])
        )
      );
  }
}
